<template>
  <v-form @submit.prevent="sendEmail" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Send timesheet reminder</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>   
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding: 10px;">
                    <v-select
                        :items="to_list"
                        :rules="[rules.required]" 
                        item-text="toDetails"
                        item-value="to"
                        label="Send To"
                        :disabled="disabled"
                        v-model="to"                  
                    ></v-select>
                </v-flex>
            </v-layout>      
            <v-layout row wrap>
                <v-flex xs12 sm6 style="padding: 10px;">
                    <v-menu v-model="menuTargetFreezeDate" :close-on-content-click="false" :nudge-right="40"
                        lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="targetFreeDate" label="Target Date to Freeze Period" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="targetFreeDate" :allowed-dates="allowedDates" @input="menuTargetFreezeDate = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12 sm6 style="padding: 10px;">
                    <v-menu v-model="menuTargetCloseDate" :close-on-content-click="false" :nudge-right="40"
                        lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="targetCloseDate" label="Target Date to Close Period" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="targetCloseDate" :allowed-dates="allowedDates" @input="menuTargetCloseDate = false"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding: 10px;">
                    <v-textarea v-model="message" :rules="[rules.required]" outline label="Message" rows="2" color="primary"></v-textarea>
                </v-flex>
            </v-layout>  
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="error" :loading="loading" style="color:white">Send</v-btn>
            <v-btn @click="clearForm" :disabled="disabled" >Clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

    import cutoffApi from '@/api/cutoff'

    export default {
        data () {
            return {
                loading: false,
                disabled: false,     
                rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                } 
                },
                teamName: '',
                description: '',
                error: false,
                errorMessage: '', 
                
                cutoff_periods: [],
                to_list: [
                    {to: 1, toDetails: "Supervisors and Admins"},
                    {to: 2, toDetails: "All Employees"},
                ],
                to: null,
                menuTargetFreezeDate: null,
                targetFreeDate: null,
                menuTargetCloseDate: null,
                targetCloseDate: null,
                message: null,
                cutOffId: null
            }
        },
    methods: {
        setCutOffId(cutOffId) {
            console.log('setCutOffId: ' + cutOffId)
            this.cutOffId = cutOffId
        },
        closeDialog() {
           this.$emit('update:dialogEmail', false)
           this.clearForm()
        },
        allowedDates(val) {
            return this.$moment(Date()).format('YYYY-MM-DD') <= this.$moment(val).format('YYYY-MM-DD')
        },
        async sendEmail() {
          if (this.$refs.form.validate()) {
            try
            {
                this.loading = true
                this.disabled = true
                
                var data = {
                    to: this.to,
                    cutOffId: this.cutOffId,
                    targetFreeDate: this.targetFreeDate,
                    targetCloseDate: this.targetCloseDate,
                    message: this.message
                }
                
                const response = await cutoffApi.sendReminder(data)

                if (response.status == 200) {
                    this.closeDialog()

                    this.loading = false
                    this.disabled = false

                    this.$emit('send', '')
                }
            }
            catch(error) {
                this.errorMessage = error

                this.error = true
                this.loading = false
                this.disabled = false
            }
          }
       },
      clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
      },
    },
    computed: {
    },
    created() {
    }
  }
</script>